export default __webpack_public_path__ + "media/images/false-8fd11babfa777bf4494f1ed813bbff19.png";